// @ts-check

import ProfileEnum from 'containers/pages/profile/ts/profileEnum';
import { validatePassword, VALID_MSG } from '@sds-stream/function-validations';

/**
 * @function checkPasswordMatch
 * @param {string} password
 * @param {string} confirmPassword
 * @returns {boolean}
 */
function checkPasswordMatch(password, confirmPassword) {
	return password === confirmPassword;
}

/**
 * @function handleValidPassword
 * @param {string} name
 * @param {string} value
 * @param {string} password
 * @param {string} confirmPassword
 * @param {function} setValid
 * @returns {void}
 */
function handleValidPassword(name, value, password, confirmPassword, setValid) {
	const { PASSWORD, CONFIRM_PASSWORD } = ProfileEnum;
	// const { MSG_PASSWORD_MISMATCH } = validationMessage;

	switch (name) {
		case PASSWORD:
			const { hasError, errorMessage } = validatePassword(value);

			setValid((prev) => ({
				...prev,
				[name]: { hasErr: hasError, msg: errorMessage, canNotSave: hasError },
				[CONFIRM_PASSWORD]: {
					hasErr: !checkPasswordMatch(value, confirmPassword),
					msg: checkPasswordMatch(value, confirmPassword) ? '' : VALID_MSG.PASSWORD_MISMATCH,
					canNotSave: !checkPasswordMatch(value, confirmPassword),
				},
			}));
			break;
		case CONFIRM_PASSWORD:
			setValid((prev) => ({
				...prev,
				[name]: {
					hasErr: !checkPasswordMatch(password, value),
					msg: checkPasswordMatch(password, value) ? '' : VALID_MSG.PASSWORD_MISMATCH,
					canNotSave: !checkPasswordMatch(password, value),
				},
			}));
			break;
		default:
			break;
	}
}

export default handleValidPassword;
